import { Instance } from 'mobx-state-tree';
import { InsightsOverTimeBinDtoModelBase } from './InsightsOverTimeBinDtoModel.base';

/* The TypeScript type of an instance of InsightsOverTimeBinDtoModel */
export interface InsightsOverTimeBinDtoModelType extends Instance<typeof InsightsOverTimeBinDtoModel.Type> {}

/* A graphql query fragment builders for InsightsOverTimeBinDtoModel */
export { selectFromInsightsOverTimeBinDto, insightsOverTimeBinDtoModelPrimitives, InsightsOverTimeBinDtoModelSelector } from './InsightsOverTimeBinDtoModel.base';

/**
 * InsightsOverTimeBinDtoModel
 */
export const InsightsOverTimeBinDtoModel = InsightsOverTimeBinDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
